import React, { Component } from 'react'
import {ActivityIndicator, StyleSheet, View} from 'react-native';

class Loadingminier extends Component {
  render () {
    return (
        <View style={[styles.container, styles.horizontal]}>
          <ActivityIndicator size="small" color="#FFFFFF" />
        </View>
    )
  }
}
const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
  },
  horizontal: {
    flexDirection: 'row',
    justifyContent: 'space-around',
    padding: 2,
  },
});
export default Loadingminier;